import React from "react";
import ExpandableTab from "components/ExpandableTab";
import TwoRowDownSingle from "./TwoRowDownSingle";

const ExpandableTwoRowDown = ({
    title = "",
    data = {},
    lClassName = "",
    containerClassname = "",
    rowContainerClassname = "",
    rClassName = "",
    emptyFieldReplacer = "-----",
    children = null,
    lChecker,
    rChecker,
    rowLastContainerClassname, // don't initialize rowLastContainerClassname
    setIsEditable = "",
    isEditable = false,
    expandTab = false,
    isIndicatorShow = false
}) => {
    let keys = Object.keys(data),
        maxIndex = keys.length - 1;

    return (
        <ExpandableTab title={title} expandTab={expandTab} isIndicatorShow={isIndicatorShow}>
            <div className={containerClassname ? containerClassname : "px-4 py-8"}>
                {isEditable && (
                    <span
                        className="flex justify-end cursor-pointer text-16 fw-500"
                        onClick={() => {
                            setIsEditable(true);
                        }}
                    >
                        Edit
                    </span>
                )}
                {keys.map((key, index) => {
                    return (
                        <TwoRowDownSingle
                            key={index}
                            className={
                                index === maxIndex && typeof rowLastContainerClassname === "string"
                                    ? rowLastContainerClassname
                                    : rowContainerClassname
                            }
                            lClassName={lClassName ? lClassName : "fw-500 text-14 secondary-light-color"}
                            rClassName={rClassName ? rClassName : "text-16 fw-500"}
                            left={typeof lChecker === "function" ? lChecker(key) : key}
                            right={
                                typeof rChecker === "function" ? rChecker(data[key]) : data[key] || emptyFieldReplacer
                            }
                        />
                    );
                })}
                {children}
            </div>
        </ExpandableTab>
    );
};

export default ExpandableTwoRowDown;
